import { render } from "./KoruLoading.vue?vue&type=template&id=a492e70e&ts=true"
import script from "./KoruLoading.vue?vue&type=script&lang=ts"
export * from "./KoruLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__